import { name } from "./mulesoft.reducers";

export const selectSlice = (state) => state[name];

export const selectMulesoftEndpoints = (state) =>
  selectSlice(state).mulesoftEndpoints;

export const selectMulesoftServices = (state) =>
  selectSlice(state).mulesoftServices;

export const selectMulesoftSwaggerData = (state) =>
  selectSlice(state).swaggerData;

export const selectMulesoftDeployStatus = (state) =>
  selectSlice(state).mulesoftDeployStatus;

export const selectSelectedMulesoftEndpoint = (state) =>
  selectSlice(state).selectedMulesoftEndpoint;

export const selectMuleIntegrations = (state) =>
  selectSlice(state).integrations;

export const selectMuleIntegrationsFilters = (state) =>
  selectSlice(state).mulesoftIntegrationsFilters;

export const selectSelectedIntegration = (state) =>
  selectSlice(state).selectedIntegration;

export const selectSelectedIntegrationId = (state) =>
  selectSlice(state).selectedIntegrationId;
